export class IngusionFormula {
    id = null;
    drugs = [];
    infusionUnit = null;
    speed = null;
    speedUnit = null;
}